(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-toc"] && !Shopify.designMode) return;
  try {
    (function () {
  var DIACRITICS_RANGE = String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f);
  var DIACRITICS_REGEX = new RegExp('[' + DIACRITICS_RANGE + ']', 'g');

  function slugify(text) {
    return text
      .normalize('NFD')
      .replace(DIACRITICS_REGEX, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildToc() {
    var toc = document.querySelector('[data-article-toc]');
    var content = document.querySelector('.article-template__content');
    if (!toc || !content) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      toc.remove();
      return;
    }

    var list = toc.querySelector('[data-article-toc-list]');
    var usedSlugs = {};
    var currentH2Item = null;

    headings.forEach(function (heading) {
      var text = heading.textContent || '';
      var baseSlug = slugify(text) || 'section';
      var slug = baseSlug;
      var counter = 2;
      while (usedSlugs[slug]) {
        slug = baseSlug + '-' + counter;
        counter += 1;
      }
      usedSlugs[slug] = true;
      heading.id = slug;

      var link = document.createElement('a');
      link.href = '#' + slug;
      link.textContent = text;

      var item = document.createElement('li');
      item.appendChild(link);

      if (heading.tagName === 'H2') {
        list.appendChild(item);
        currentH2Item = item;
      } else if (currentH2Item) {
        var sublist = currentH2Item.querySelector('ol');
        if (!sublist) {
          sublist = document.createElement('ol');
          currentH2Item.appendChild(sublist);
        }
        sublist.appendChild(item);
      } else {
        list.appendChild(item);
      }
    });

    list.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upsell-card"] && !Shopify.designMode) return;
  try {
    (function () {
  var STORAGE_PREFIX = 'zoluko_upsell_';

  function readState(variantId) {
    try {
      return window.sessionStorage.getItem(STORAGE_PREFIX + variantId) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeState(variantId, on) {
    try {
      window.sessionStorage.setItem(STORAGE_PREFIX + variantId, on ? '1' : '0');
    } catch (e) {}
  }

  function isOn(variantId) {
    var input = document.querySelector('.zoluko-upsell__input[data-upsell-variant="' + variantId + '"]');
    return !!(input && input.checked);
  }

  function syncAll() {
    document.querySelectorAll('.zoluko-upsell__input').forEach(function (input) {
      input.checked = readState(input.getAttribute('data-upsell-variant'));
    });
    document.querySelectorAll('[data-upsell-note]').forEach(function (note) {
      note.hidden = !isOn(note.getAttribute('data-upsell-note'));
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('zoluko-upsell__input')) return;
    writeState(input.getAttribute('data-upsell-variant'), input.checked);
    syncAll();
  });

  function postToCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var holder = form.closest('[data-upsell-variant]');
      if (!holder) return;
      var upsellVariant = holder.getAttribute('data-upsell-variant');
      if (!isOn(upsellVariant)) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.getAttribute('data-upsell-busy') === 'true') return;
      form.setAttribute('data-upsell-busy', 'true');

      var button = form.querySelector('[type="submit"]');
      var spinner = form.querySelector('.loading__spinner');
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      var returnInput = form.querySelector('[name="return_to"]');
      var returnTo = returnInput && returnInput.value ? returnInput.value : (window.routes && window.routes.cart_url) || '/cart';

      var mainData = new FormData(form);
      mainData.delete('return_to');
      var quantity = parseInt(mainData.get('quantity'), 10) || 1;

      postToCart(addUrl, mainData)
        .then(function (response) {
          if (!response.ok) throw new Error('main-add-failed');
          var upsellData = new FormData();
          upsellData.append('id', upsellVariant);
          upsellData.append('quantity', quantity);
          return postToCart(addUrl, upsellData).catch(function () {});
        })
        .then(function () {
          window.location.href = returnTo;
        })
        .catch(function () {
          form.removeAttribute('data-upsell-busy');
          if (button) {
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
          }
          if (spinner) spinner.classList.add('hidden');
          form.submit();
        });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('pageshow', syncAll);
})();
  } catch(e) { console.error(e); }
})();

})();
